module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/EMPIRE_01.b00f48c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/EMPIRE_01.jpg
// module id = uFCC
// module chunks = 0